import script from "./ReputationView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReputationView.vue?vue&type=script&setup=true&lang=js"

import "./ReputationView.vue?vue&type=style&index=0&id=1b783c5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b783c5c"]])

export default __exports__